/**
 *左侧导航菜单 vm
 *@author xujinjiang
 *@date 2022/3/1 15:08
 */

import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import { Menu } from '@/constant/Menu';
import { ObserverService } from '@/service/ObserverService';
import router from '@/router/index';
import { RouterUtil } from '@/utils/RouterUtil';

export class MenuViewModel extends BaseViewModel {
  menu: any = Menu;
  getRouteSubscription: any;
  currentKey = 'home';
  private defaultActive = 'home';
  private homeActive = false; // 首页选中状态
  private accountActive = false; // 账户选中状态
  private institutionActive = false; // 机构管理选中状态
  private authorizationUserActive = false; // 授权用户选中状态

  mounted() {
    const route = this.$route.path;
    this.defaultActive = route.replace('/cms/', '');
    this.initObserver();
  }

  unmounted() {
    if (this.getRouteSubscription) {
      this.getRouteSubscription.unsubscribe();
    }
  }

  private initObserver() {
    this.getRouteSubscription = ObserverService.getInstance()
      .getRouteObserver()
      .subscribe((route: any) => {
        if (!route || route.length === 0) {
          return;
        }
        this.defaultActive = route;
        this.handlerMenuImgVisible(route);
      });
  }

  select(key: any) {
    if (key === Menu.account.path) {
      return;
    }
    // 打开开发与操作帮助文档
    if (key === Menu.doc.path) {
      this.$router.push(`/cms/${this.currentKey}`).then();
      RouterUtil.openDoc(this.$router);
      return;
    }
    this.defaultActive = key;
    this.currentKey = key;
    this.handlerMenuImgVisible(key);
  }

  handlerMenuImgVisible(key: any) {
    this.homeActive = false;
    this.accountActive = false;
    this.institutionActive = false;
    this.authorizationUserActive = false;
    switch (key) {
      case Menu.home.path:
        this.homeActive = true;
        break;
      case Menu.institutions.path:
        this.institutionActive = true;
        break;
      case Menu.authorizationUser.path:
        this.authorizationUserActive = true;
        break;
      case Menu.accountManage.path:
      case Menu.accountLog.path:
        this.accountActive = true;
        break;
    }
  }
}
